import {
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import DIRECTV_GO from '~/assets/DIRECTV_GO_LOGO_HORIZONTAL_RGB.svg';
import logoSky from '~/assets/log-SKY.svg';
import { ApplicationState } from '~/store';
import { AuthState } from '~/store/ducks/auth/types';
import {
  FormControlLGPD,
  StyledButton,
  StyledTextField,
  Wrapper,
  WrapperTest,
} from './styles';

interface IProps {
  nexAuth(): void;
  handleChange(): void;
  handleChangeOwnership: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleClickShowPassword?:
    | ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
    | undefined;
  handleMouseDownPassword(): void;
  showPassword: Boolean;
  password: string;
  ownership: any;
  children: React.ReactNode;
  company: string;
  ownershipStringValue: string;
  identificationKey: string;
}

interface StateProps {
  language: any;
  auth: AuthState;
  common: any;
}

type Props = StateProps & IProps;

class EnterPassword extends Component<Props> {
  componentDidMount() {
    document.title = 'Insira sua senha | Portal LGPD';
  }

  setLogo = (company: number) => {
    if (company === 1) {
      return logoSky;
    } else {
      return DIRECTV_GO;
    }
  };

  render() {
    const {
      nexAuth,
      children,
      showPassword,
      password,
      handleChange,
      handleClickShowPassword,
      handleMouseDownPassword,
      company,
      identificationKey,
      ownershipStringValue,
      ownership,
      language,
      auth,
    } = this.props;

    return (
      <WrapperTest>
        <Wrapper>
          <div className="content-small">
            <div className="vrio-corp">
              <span>Vrio Corp</span>
            </div>

            <div className="welcome">
              <h2>{language?.login?.bemVindo}</h2>
              <h1>{language?.login?.LGPDSystem}</h1>
            </div>
          </div>
          <div className="container-form">
            <form action="">
              <div className="header">
                {auth.company?.country_company_id ? (
                  <img
                    src={this.setLogo(auth.company.country_company_id)}
                    alt={`logo ${auth.company?.company?.company_name?.toUpperCase()}`}
                  />
                ) : (
                  ''
                )}

                <h1>{language?.login?.insiraSuaSenha}</h1>
              </div>

              <StyledTextField
                id="country-company"
                disabled
                label={language?.login?.paisEmpresa}
                value={company}
                variant="outlined"
              />

              <StyledTextField
                id="country-company"
                disabled
                label={language?.login?.categoria}
                value={ownershipStringValue}
                variant="outlined"
              />

              <StyledTextField
                disabled
                id="identification-key"
                name="identification-key"
                value={identificationKey}
                label={
                  ownership === '5' && auth.company.country_company_id === 2
                    ? 'E-mail'
                    : language?.login?.chaveDeIdentificacao
                }
                variant="outlined"
              />

              <FormControlLGPD variant="outlined">
                <InputLabel htmlFor="outlined-adornment-password">
                  {language?.login?.senha}
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={handleChange}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                  labelWidth={70}
                />
              </FormControlLGPD>

              <div className="ReCAPTCHA">{children}</div>

              <div className="StyledButton-align">
                <StyledButton className="button-continue" onClick={nexAuth}>
                  {!!language?.login?.continuar && language?.login?.continuar}
                </StyledButton>
              </div>
            </form>

            <div className="nav-options">
              <p>
                <a href={`/${auth?.company?.path_alias_nm}`}>
                  {language?.login?.facaLoginEmUmaContaDiferente}
                </a>
              </p>
              <p>
                <a href={`/${auth?.company?.path_alias_nm}/contactdpo`}>
                  {language?.login?.solicitarAjudaAoDPO}
                </a>
              </p>
            </div>

            <p className="footer">
              {language?.login?.politicaGoogle.parte_1}{' '}
              <a
                href="https://policies.google.com/privacy?hl=pt"
                target="_blank"
                rel="noopener noreferrer"
              >
                {language?.login?.politicaGoogle.parte_2}
              </a>{' '}
              {language?.login?.politicaGoogle.parte_3}{' '}
              <a
                href="https://policies.google.com/terms?hl=pt"
                target="_blank"
                rel="noopener noreferrer"
              >
                {language?.login?.politicaGoogle.parte_4}
              </a>{' '}
              {language?.login?.politicaGoogle.parte_5}
            </p>
          </div>
        </Wrapper>
      </WrapperTest>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  language: state.language.data,
  auth: state.auth,
  common: state.common,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  ...bindActionCreators({}, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(EnterPassword);
